import {
  fromEvent,
  startWith,
  map,
  distinctUntilChanged,
  shareReplay,
  merge,
  of,
  combineLatest,
} from "rxjs";

const visible$ = fromEvent(document, "visibilitychange").pipe(
  startWith(0),
  map(() => document.visibilityState === "visible"),
  distinctUntilChanged(),
  shareReplay({ bufferSize: 1, refCount: true }),
);

const online$ = merge(
  fromEvent(window, "online").pipe(map(() => true)),
  fromEvent(window, "offline").pipe(map(() => false)),
  of(navigator.onLine),
).pipe(distinctUntilChanged(), shareReplay({ bufferSize: 1, refCount: true }));

export const onlineAndVisible$ = combineLatest([visible$, online$]).pipe(
  map(([v, o]) => v && o),
  distinctUntilChanged(),
  shareReplay({ bufferSize: 1, refCount: true }),
);
